import React, { useState, useEffect } from "react";
import "react-phone-input-2/lib/style.css";

import {
  Form,
  Input,
  Select,
  message,
  InputNumber,
  Radio,
  Spin,
} from "antd";

import {  LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import PhoneInput from "react-phone-input-2";
import { lookUp } from "../../../api/LookUpAPI";
import { verifyPhysician, physicianSignUp } from "../../../api/PhysiciansAPI";

const { TextArea } = Input;

import {
  StyledComponentWrapper,
  StyledFlexBreaker,
  StyledFormItem,
  StyledFormItemName,
  StyledRegisterButton,
  StyledDatePicker,
  Title,
} from './styles'

const PhysicianRegister = () => {
  const [form] = Form.useForm();

  const [fetchstates, SetFetchstates] = useState();
  const [fetchTelemedicine, setFetchTelemedicine] = useState();
  const [fetchClients, setFetchClients] = useState();
  const [DOB, setDOB] = useState();
  const [loading, setLoading] = useState(false);
  const [fetchDoctorCredentials, setFetchDoctorCredentials] = useState();
  const [employmentStatus, setEmploymentStatus] = useState([]);
  const [question1Change, setQuestion1Change] = useState();
  const [question2Change, setQuestion2Change] = useState();
  const [question5Change, setQuestion5Change] = useState();

  const timeZoneList = dayjs.tz.names()

  async function handleNPICheck(fName, lName, npi) {
    try {
      const { status, data } = await verifyPhysician(npi, fName, lName)

      if (status === 200) {
        if (data?.message !== "Valid NPI number") {
          message.error("NPI or first and last name is invalid");
          return false
        }
        return true
      }

      message.error("NPI verfication service failed");
      return false
    } catch ({ response }) {
      if (response?.data?.message) message.error(response.data.message)
      else message.error("Unable to verify NPI number. Please try to register after a while!");
      return false
    }
  }

  const onFinish = async values => {
    try {
      const validNPI = await handleNPICheck(values.firstName, values.lastName, values.npi)
      if (!validNPI) return false
    } catch (e) {
      message.error(e)
      return false
    }

    setLoading(true);

    const physician = {
      ...values,
      address2: values.address2 || "",
      DOB,
      offSet: values.offSet
        ? dayjs.tz(values.offSet).utcOffset()
        : new Date().getTimezoneOffset(),
      offSetName: values.offSet || dayjs.tz.guess(true),
    }

    physicianSignUp(physician)
      .then(({ data }) => {
        if (data?.status) {
          form.resetFields();
          return message.success("Successfully Registered Physician");
        } 

        if (data?.message)
          return message.error(data.message);

        message.error("Physician Registration Failed. Please try again!");
      }).catch((error) => {
        const { response, data } = error
        if (!response) return console.log(error)

        if (response.status === 409 && response.data.message)
          return message.error(response.data.message);

        if (data?.message)
          return message.error(data.message); 
          
        message.error("Physician Registration Failed. Please try again!");
      }).finally(() => setLoading(false))
  };

  useEffect(() => {
    const responseState = [];
    const responsetelemedicine = [];
    const responseClient = [];
    const responseCredential = [];

    lookUp("state").then(({ data }) => {
      if (data) {
        data.payload.map((state) => {
          return responseState.push({
            key: state._id,
            value: state.name,
            text: state.name,
          });
        });
        SetFetchstates(responseState);
      }
    });

    lookUp("tele-medicine-category").then(({ data }) => {
      if (data) {
        data.payload.map((state) => {
          return responsetelemedicine.push({
            key: state._id,
            value: state.name,
            text: state.name,
          });
        });
        setFetchTelemedicine(responsetelemedicine);
      }
    });

    lookUp("credential").then(({ data }) => {
      if (data) {
        data.payload.map((eachCredential) => {
          return responseCredential.push({
            key: eachCredential._id,
            value: eachCredential.name,
            text: eachCredential.name,
          });
        });
      }
      
      setFetchDoctorCredentials(responseCredential);
    });

    lookUp("client").then(({ data }) => {
      if (data) {
        data.payload.map((state) => {
          return responseClient.push({
            key: state._id,
            value: state.name,
            text: state.name,
          });
        });
        setFetchClients(responseClient);
      }
    });

    lookUp("physician-group").then(({ data }) => {
      if (data) {
        const { payload } = data;
        const allowedPhysicianGroup = ["external physicians", "internal physicians", "steadymd physicians"];

        if (payload?.length) {
          const allowedPhysicianGroupList = payload.filter(({ name }) => allowedPhysicianGroup.includes(name));
          const physicianGroupData = allowedPhysicianGroupList.map(({ _id, name }) => ({ key: _id, value: _id, text: name }))
          setEmploymentStatus(physicianGroupData);
        }
      }
    });
  }, []);

  return (
    <StyledComponentWrapper>
      <Spin spinning={loading} size="large" indicator={<LoadingOutlined />}>
        <Title level={2}> Add Physician </Title>
        <Form
          form={form}
          name=" physician register"
          layout="vertical"
          size="large"
          onFinish={onFinish}
        >
          <StyledFlexBreaker>
            <Form.Item
              name="credential"
              label="Credential"
              rules={[{ required: true, message: "Required" }]}
            >
              <Select
                id="physician-register-credential-select"
                placeholder="Select"
                getPopupContainer={(trigger) => trigger.parentElement}
                options={fetchDoctorCredentials?.map(({ value, text }) => ({ value, label: text }))}
              />
            </Form.Item>
            <StyledFormItemName
              name="firstName"
              label="First Name"
              rules={[{ required: true, message: "Please input your First Name!", whitespace: true }]}
            >
              <Input id="physician-register-first-name-input" placeholder="First Name"/>
            </StyledFormItemName>
            <StyledFormItemName
              name="lastName"
              label="Last Name"
              rules={[{ required: true, message: "Please input your Last Name!", whitespace: true }]}
            >
              <Input id="physician-register-last-name-input" placeholder="Last Name"/> 
            </StyledFormItemName>
          </StyledFlexBreaker>

          <Form.Item
            name="npi"
            label="NPI"
            rules={[{ required: true,  message: "Please input your NPI Number!" }]}
          >
            <InputNumber id="physician-register-npi-input" placeholder="NPI" style={{ width: "100%" }}/>
          </Form.Item>

          <Form.Item
            name="email"
            label="E-mail"
            rules={[
              {
                type: "email",
                message: "The input is not valid E-mail!",
              },
              {
                required: true,
                message: "Please input your E-mail!",
              },
            ]}
          >
            <Input id="physician-register-email-input" placeholder="E-mail" />
          </Form.Item>

          <StyledFlexBreaker>
            <StyledFormItem
              name="teleMedicineCategories"
              label="Telemedicine Categories"
              rules={[{ required: true, message: "Please input your Telemedicine Categories!" }]}
            >
              <Select
                id="physician-register-categories-select"
                mode="multiple"
                placeholder="Select Category"
                showArrow
                getPopupContainer={(trigger) => trigger.parentElement}
                filterOption={(input, { children }) => children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                options={fetchTelemedicine?.map(({ key, text }) => ({ value: key, label: text }))}
              />
            </StyledFormItem>

            <StyledFormItem
              name="states"
              label="States"
              rules={[{ required: true, message: "Please input your States!" }]}
            >
              {
                  /* TODO: fix filtering below component */
                }
              <Select
                id="physician-register-states-select"
                mode="multiple"
                placeholder="Select States"
                showArrow 
                filterOption={(input, { children }) => children?.toLowerCase().indexOf(input.toLowerCase()) >= 0 }
                options={fetchstates?.map(({ key, text }) => ({ value: key, label: text }))}
              />
            </StyledFormItem>
          </StyledFlexBreaker>

          <StyledFlexBreaker>
            <StyledFormItem
              name="clients"
              label="Clients"
              rules={[{ required: true,  message: "Please Input your Clients!" }]}
            >
              <Select
                id="physician-register-clients-select"
                mode="multiple"
                placeholder="Select Clients"
                showArrow
                getPopupContainer={(trigger) => trigger.parentElement}
                filterOption={(input, { children }) => children.toLowerCase().indexOf(input.toLowerCase()) >= 0 }
                options={fetchClients?.map(({key, text }) => ({ value: key, label: text }))}
              />
            </StyledFormItem>

            <StyledFormItem
              name="DOB"
              label="Date of Birth"
              rules={[{ required: true, message: "Please Input your DOB!" }]}
            >
              <StyledDatePicker
                id="physician-register-dob-datepicker"
                getPopupContainer={(trigger) => trigger.parentElement}
                placeholder="Select DOB"
                onChange={(_, dateString) => setDOB(dateString)}
                disabledDate={e => !!e && e.valueOf() > Date.now()}
              />
            </StyledFormItem>
          </StyledFlexBreaker>
          <Form.Item
            name="address1"
            label="Address Line 1"
            rules={[{required: true, message: "Please Input your Address!", whitespace: true}]}
          >
            <Input id="physician-register-address1-input" placeholder="Address Line 1" />
          </Form.Item>

          <Form.Item
            name="address2"
            label="Address Line 2"
            defaultValue=""
            rules={[{ whitespace: true }]}
          >
            <Input id="physician-register-address2-input" placeholder="Address Line 2" />
          </Form.Item>

          <StyledFlexBreaker>
            <StyledFormItem
              name="city"
              label="City"
              rules={[{ required: true, message: "Please Input your City!", whitespace: true }]}
            >
              <Input id="physician-register-city-input" placeholder="city" />
            </StyledFormItem>

            <StyledFormItem
              name="state"
              label="State"
              rules={[{ required: true, message: "Please Input your State!", whitespace: true }]}
            >
              <Select
                id="physician-register-state-select"
                placeholder="Select State"
                getPopupContainer={(trigger) => trigger.parentElement}
                options={fetchstates?.map(({ text }) => ({ value: text, label: text}))}
              />
            </StyledFormItem>
          </StyledFlexBreaker>

          <StyledFlexBreaker>
            <StyledFormItem
              name="zipCode"
              label="Zip Code"
              rules={[
                {
                  required: true,
                  message: "Please Input your Zip Code!",
                },
              ]}
            >
              <Input id="physician-register-zip-code-input" placeholder="Zip Code" style={{ width: "100%" }} />
            </StyledFormItem>

            <StyledFormItem
              name="phone"
              label="Phone Number"
              rules={[
                {
                  required: true,
                  message: "Please Input your Phone Number!",
                },
              ]}
            >
              <PhoneInput
                inputProps={{ id: "physician-register-phone-input" }}
                placeholder="Enter Phone Number"
                onlyCountries={["us"]}
                disableDropdown="false"
                country="us"
              />
            </StyledFormItem>
          </StyledFlexBreaker>
          <StyledFlexBreaker>
            <StyledFormItem
              name="employmentStatus"
              label="Employment Status"
              rules={[
                {
                  required: true,
                  message: "Please Input your Employment Status",
                },
              ]}
            >
              <Select
                id="physician-register-employment-status-select"
                placeholder="Select Employment Status"
                getPopupContainer={trigger => trigger.parentElement}
                style={{ textTransform: 'capitalize'}}
                options={employmentStatus?.map(({ value, text }) => ({ value, label: text }))}
              />
            </StyledFormItem>
            <StyledFormItem name="offSet" label="Time Zone">
              <Select
                id="physician-register-timezone-select"
                showSearch
                allowClear={true}
                className="timezone-select"
                placeholder="Select the required Time Zone"
                filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                optionFilterProp="children"
                options={timeZoneList?.map(zone => ({ value: zone, label: zone }))}
              />

            </StyledFormItem>
          </StyledFlexBreaker>
          <Form.Item>
            <StyledRegisterButton
              id="physician-register-create-account-btn"
              type="primary"
              size="large"
              htmlType="submit"
              className="register-physician-form-button"
            >
              Create Account
            </StyledRegisterButton>
          </Form.Item>
        </Form>
      </Spin>
    </StyledComponentWrapper>
  );
};

export default PhysicianRegister;
